<template>
  <Teleport to="body">
    <Transition
        name="slide-up"
        enter-active-class="transition-all duration-300 ease-out"
        enter-from-class="transform translate-y-full opacity-0"
        enter-to-class="transform translate-y-0 opacity-100"
        leave-active-class="transition-all duration-300 ease-in"
        leave-from-class="transform translate-y-0 opacity-100"
        leave-to-class="transform translate-y-full opacity-0"
    >
      <div
          v-if="store.showBanner"
          class="cookie-consent-banner"
      >
        <div class="banner-content">
          <div class="banner-text">
            <p class="text-sm mb-3">
              {{ $t('rgpd.consent.text1') }}
              <NuxtLink
                  to="/privacy-policy/privacy"
                  class="text-green-400 underline hover:text-green-300"
              >
                {{ $t('rgpd.consent.text2') }}
              </NuxtLink>.
            </p>
          </div>

          <div class="banner-actions">
            <button
                @click="store.acceptAllCookies"
                class="btn-accept"
            >
              {{ $t('rgpd.consent.btn1') }}
            </button>

            <button
                @click="store.declineAllCookies"
                class="btn-decline"
            >
              {{ $t('rgpd.consent.btn2') }}
            </button>

            <button
                @click="showPreferences = true"
                class="btn-customize"
            >
              {{ $t('rgpd.consent.customize') }}
            </button>

            <button
                @click="store.dismissBanner"
                class="btn-dismiss"
                title="Fermer temporairement"
            >
              <Icon name="heroicons:x-mark" class="h-4 w-4" />
            </button>
          </div>
        </div>

        <!-- Modal de préférences -->
        <CookiePreferencesModal
            v-if="showPreferences"
            @close="showPreferences = false"
            @save="handlePreferencesSave"
        />
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>

import {useCookieConsentStore} from "~/stores/cookieConsent/index.js";

const showPreferences = ref(false)
const store = useCookieConsentStore()

// const {
//   shouldShowBanner:showBanner,
//   acceptAllCookies,
//   declineAllCookies,
//   dismissBanner
// } = useCookieConsent()

const handlePreferencesSave = (preferences) => {
  store.acceptWithPreferences(preferences)
  showPreferences.value = false
}

// Initialiser au montage
onMounted(() => {
  store.initializeFromCookies()
})
</script>

<style scoped>
.cookie-consent-banner {
  @apply fixed bottom-0 left-0 right-0 bg-green-900 text-white p-4 z-50;
  background: rgba(15, 71, 9, 0.95);
  backdrop-filter: saturate(180%) blur(20px);
}

.banner-content {
  @apply max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-4;
}

.banner-text {
  @apply flex-1 text-center lg:text-left;
}

.banner-actions {
  @apply flex flex-wrap gap-2 justify-center lg:justify-end;
}

.btn-accept {
  @apply bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded transition-colors;
}

.btn-decline {
  @apply bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded transition-colors;
}

.btn-customize {
  @apply bg-blue-500 hover:bg-blue-600 text-white px-3 py-2 rounded text-sm transition-colors;
}

.btn-dismiss {
  @apply bg-transparent hover:bg-white/10 text-white p-2 rounded transition-colors;
}
</style>